var map = {
	"./1-_DSC0083.jpg": 67,
	"./2-_DSC9286.jpg": 68,
	"./3-_DSC7085.jpg": 69,
	"./4-_DSC7160.jpg": 70,
	"./5-_DSC7175.jpg": 71,
	"./6-_DSC9276.jpg": 72,
	"./7-_DSC0732.jpg": 73
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 26;